export const viewTitle = "Справочник ОИК";
export const viewUniqKey = "oik";
